import { TvlAreaChart } from '@/components/charts/tvlAreaChart'
import { DefinitionStat } from '@/components/common/definitionStat'
import type { HistoricalData } from '@/queries/historical.query'
import type { Vault } from '@/types/vault'
import { getValueColor } from '@/utils/styles/getValueColor'
import { formatTokenValue } from '@vaultsfyi/common/utils'
import type { ReactNode } from 'react'
import { TabHeader } from './tabHeader'

interface Props {
  vault: Vault
  chartData: HistoricalData
  tvlPeriodChange: number | null
  rangeSelector?: ReactNode
  chartClassName?: string
  showBrush?: boolean
}

export const TvlPerformance = ({
  vault,
  chartData,
  tvlPeriodChange,
  rangeSelector,
  chartClassName,
  showBrush = false,
}: Props) => {
  const { tvl, asset } = vault
  return (
    <div className="flex flex-col gap-4 pt-2">
      <TabHeader
        title="TVL - detailed view"
        description="Total Value Locked represents the value of deposits currently held in this vault."
      />
      <div className="flex flex-wrap items-end justify-between gap-x-8 gap-y-3">
        <dl className="flex max-w-full shrink-0 flex-wrap gap-x-8 gap-y-3">
          <DefinitionStat
            label="Total locked"
            value={`${formatTokenValue({ value: tvl.native, decimals: asset.decimals })} ${asset.symbol}`}
            className="gap-0.5"
            labelClassName="font-normal text-body-foreground"
          />
          {tvlPeriodChange != null && (
            <DefinitionStat
              label="Period change"
              value={`${tvlPeriodChange > 0 ? '+' : ''}${tvlPeriodChange.toFixed(2)}%`}
              className="gap-0.5"
              labelClassName="font-normal text-body-foreground"
              valueClassName={getValueColor(tvlPeriodChange)}
            />
          )}
        </dl>
        {rangeSelector && <div className="shrink-0">{rangeSelector}</div>}
      </div>
      <TvlAreaChart data={chartData} className={chartClassName} showBrush={showBrush} />
    </div>
  )
}
